"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5941],{

/***/ 95941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PushTraits_PushTraits; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/components/Brandbook/EmailIcon.tsx
var EmailIcon = __webpack_require__(73951);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/components/Brandbook/UserIcon.tsx
var UserIcon = __webpack_require__(75686);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/EventItem/EventItem.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}






var _ref =  true ? {
  name: "n87mc",
  styles: "display:grid;grid-gap:16px;grid-template-columns:min-content auto max-content;grid-template-areas:'icon body detail';padding:12px"
} : 0;

var EventItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "eepih5p5"
} : 0)("width:100%;position:relative;align-items:center;background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";border-radius:10px;text-align:", function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign;
}, ";", function (_ref4) {
  var size = _ref4.size;
  return size === "large" && _ref;
}, " ", function (_ref5) {
  var size = _ref5.size;
  return size === "small" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("padding:14px 16px;", Detail, "{position:absolute;top:12px;right:12px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconWrapper/* default */.Z,  true ? {
  target: "eepih5p4"
} : 0)( true ? {
  name: "aiako2",
  styles: "grid-area:icon"
} : 0);
var EventItemBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eepih5p3"
} : 0)( true ? {
  name: "m5ao3r",
  styles: "grid-area:body;display:grid;grid-gap:2px"
} : 0);
var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eepih5p2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var Code = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eepih5p1"
} : 0)( true ? {
  name: "aufss",
  styles: "margin:0;white-space:break-spaces"
} : 0);
var Detail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eepih5p0"
} : 0)( true ? {
  name: "pl591r",
  styles: "grid-area:detail;align-self:start;margin:0"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/EventItem/EventItem.tsx



var _excluded = ["children", "size", "elevation", "tokens"],
    _excluded2 = ["children", "tokens"],
    _excluded3 = ["children", "tokens"],
    _excluded4 = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function EventItem_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}





var BaseEventItem = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 2 : _ref$elevation,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    size: size,
    elevation: elevation
  }, tokens), rest), {}, {
    children: children
  }));
});
var EventItem_EventItem = (0,useDesignTokens/* withDesignTokens */.Y)(BaseEventItem, function (_ref2, theme) {
  var _ref2$textAlign = _ref2.textAlign,
      textAlign = _ref2$textAlign === void 0 ? "left" : _ref2$textAlign,
      background = _ref2.background;
  return {
    textAlign: textAlign,
    backgroundColor: background !== null && background !== void 0 ? background : theme.palette.neutrals.white[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
}); // Compound Components

var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var children = _ref3.children,
      tokens = _ref3.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
    ref: ref,
    variant: "circle",
    tokens: tokens,
    children: children
  });
});
var EventItem_Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
var BaseCode = /*#__PURE__*/(0,react.forwardRef)(function (_ref4, ref) {
  var children = _ref4.children,
      tokens = _ref4.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Code, _objectSpread(_objectSpread({
    ref: ref,
    variant: "code"
  }, rest), {}, {
    tokens: tokens,
    children: children
  }));
});
var EventItem_Code = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCode, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.boysenberry[60]
    };
  }
});
var BaseEventItemLabel = /*#__PURE__*/(0,react.forwardRef)(function (_ref5, ref) {
  var children = _ref5.children,
      tokens = _ref5.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded3);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, _objectSpread(_objectSpread({
    ref: ref,
    variant: "buttonSmall",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var EventItem_Label = (0,useDesignTokens/* withDesignTokens */.Y)(BaseEventItemLabel, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
var BaseDetail = /*#__PURE__*/(0,react.forwardRef)(function (_ref6, ref) {
  var children = _ref6.children,
      tokens = _ref6.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded4);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Detail, _objectSpread(_objectSpread({
    ref: ref,
    variant: "textTiny",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var EventItem_Detail = (0,useDesignTokens/* withDesignTokens */.Y)(BaseDetail, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[40]
    };
  }
});
var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1r4jbxh0"
} : 0)( true ? {
  name: "m5ao3r",
  styles: "grid-area:body;display:grid;grid-gap:2px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/EventItem/index.ts

EventItem_EventItem.displayName = "EventItemBase";
EventItem_Icon.displayName = "EventItem.Icon";
Body.displayName = "EventItem.Body";
EventItem_Label.displayName = "EventItem.Label";
EventItem_Detail.displayName = "EventItem.Detail";
EventItem_Code.displayName = "EventItem.Code";

// EXTERNAL MODULE: ../../libs/matcha/recipes/Connector/index.ts + 1 modules
var Connector = __webpack_require__(17774);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/EventFlow/EventFlow.tsx


function EventFlow_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}






var defaultGradient = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
    stopColor: "#C9C3CE",
    stopOpacity: "0"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
    offset: "0.515271",
    stopColor: "#C9C3CE",
    stopOpacity: "0.5"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
    offset: "1",
    stopColor: "#C9C3CE",
    stopOpacity: "0"
  })]
});

var defaultDotsGradient = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
    stopColor: "#5C4D6B",
    stopOpacity: "0"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
    offset: "0.489183",
    stopColor: "#5C4D6B",
    stopOpacity: "0.5"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
    offset: "1",
    stopColor: "#5C4D6B",
    stopOpacity: "0"
  })]
});

var EventFlow = function EventFlow(_ref) {
  var id = _ref.id,
      gap = _ref.gap,
      gradient = _ref.gradient,
      gradientDots = _ref.gradientDots,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    gap: gap,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConnectorWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Connector/* default */.Z, {
        gradient: gradient !== null && gradient !== void 0 ? gradient : defaultGradient,
        gradientDots: gradientDots !== null && gradientDots !== void 0 ? gradientDots : defaultDotsGradient,
        gradientRotation: 90,
        height: 430,
        id: "vertical-".concat(id),
        path: "M8.00001 430.881L8 0.880859",
        width: 16
      })
    }), children]
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "egzevjx1"
} : 0)("position:relative;display:grid;row-gap:", function (_ref2) {
  var gap = _ref2.gap;
  return gap ? gap : "8px";
}, ";" + ( true ? "" : 0));

var ConnectorWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "egzevjx0"
} : 0)( true ? {
  name: "1aslf6p",
  styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/EventFlow/index.ts

;// CONCATENATED MODULE: ./src/views/Marketing/components/PushTraits/PushTraits.tsx


function PushTraits_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var events = [{
  label: "Emails Today",
  sublabel: "3",
  detail: "24s",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailIcon/* default */.Z, {})
}, {
  label: "Propensity to Buy 14 Days",
  sublabel: "75%",
  detail: "2m",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcon/* default */.Z, {})
}];
var codeEvent = {
  code: "Push traits to build real-time audiences"
};
var PushTraits = function PushTraits() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PushTraits_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventFlow, {
      id: "push-traits",
      gap: "16px",
      gradient: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "0.48183",
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0.5"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0"
        })]
      }),
      gradientDots: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "0.489183",
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        })]
      }),
      children: [events.map(function (event) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventItem_EventItem, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem_Icon, {
            children: event.icon
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Body, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem_Label, {
              tokens: {
                color: theme.palette.brand.darkAcai[400]
              },
              children: event.label
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem_Label, {
              children: event.sublabel
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem_Detail, {
            children: event.detail
          })]
        }, event.label);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem_EventItem, {
        background: theme.palette.twilio.boysenberry[60],
        size: "small",
        textAlign: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem_Code, {
            tokens: {
              color: theme.palette.neutrals.white[100]
            },
            children: codeEvent.code
          })
        })
      })]
    })
  });
};

var PushTraits_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edzmpi60"
} : 0)( true ? {
  name: "1xtw08w",
  styles: "display:grid;align-items:center;justify-content:center;min-height:430px;padding:0 14px"
} : 0);

/* harmony default export */ var PushTraits_PushTraits = (PushTraits);
;// CONCATENATED MODULE: ./src/views/Marketing/components/PushTraits/index.ts


/***/ }),

/***/ 17774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Connector_Connector; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Connector/Connector.tsx



var Connector = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var path = _ref.path,
      gradient = _ref.gradient,
      gradientDots = _ref.gradientDots,
      _ref$gradientRotation = _ref.gradientRotation,
      gradientRotation = _ref$gradientRotation === void 0 ? 0 : _ref$gradientRotation,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      id = _ref.id;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    ref: ref,
    className: className,
    fill: "none",
    children: [gradient && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      strokeLinejoin: "round",
      d: path,
      stroke: typeof gradient === "string" ? gradient : "url(#paint".concat(id, "_linear_lined)"),
      strokeWidth: "16"
    }), gradientDots && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: path,
      stroke: typeof gradientDots === "string" ? gradientDots : "url(#paint".concat(id, "_linear_lined_dots)"),
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.1 16"
    }), (typeof gradient === "object" || typeof gradientDots === "object") && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
      children: [typeof gradient === "object" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
        x1: 0,
        y1: 0,
        x2: width > height ? width : height,
        y2: 0,
        id: "paint".concat(id, "_linear_lined"),
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(".concat(gradientRotation, ")"),
        children: gradient
      }), typeof gradientDots === "object" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("linearGradient", {
        x1: 0,
        y1: 0,
        x2: width > height ? width : height,
        y2: 0,
        id: "paint".concat(id, "_linear_lined_dots"),
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(".concat(gradientRotation, ")"),
        children: gradientDots
      })]
    })]
  });
});
/* harmony default export */ var Connector_Connector = (Connector);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Connector/index.ts


/***/ })

}]);